import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_ACTIONS_TYPE,
  FILTER_ADDED,
  FILTER_APPROVERS,
  FILTER_CREATED_BY,
  FILTER_PERIOD,
} from 'scenes/FinancialResults/constants';

import * as Filters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_PERIOD,
  FILTER_ADDED,
  FILTER_ACTIONS_TYPE,
  FILTER_CREATED_BY,
  FILTER_APPROVERS,
];

const PrimaryFilters = () => (
  <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
    <Filters.Added />
    <Filters.Period />
    <Filters.ActionsType withClear={true} />
    <Filters.Approvers withClear={true} />
    <Filters.Applications withClear={true} />
    <Filters.BusinessPartners withClear={true} />
    <Filters.Affiliates withClear={true} />
    <Filters.CustomerCompanies withClear={true} />
    <Filters.ExpenseTypes withClear={true} />
    <Filters.Importance withClear={true} />
    <Filters.Statuses withClear={true} />
    <Filters.CreatedBy withClear={true} />
  </PrimaryFiltersProvider>
);

export default PrimaryFilters;
